import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum UnableToExecuteCheckoutSplitAgentReason {
  CHECKOUT_SPLIT_AGENT_WORKFLOW_RUNNING = "CHECKOUT_SPLIT_AGENT_WORKFLOW_RUNNING",
  CHECKOUT_TREE_DOES_NOT_EXIST = "CHECKOUT_TREE_DOES_NOT_EXIST",
}

export const canExecuteCheckoutSplitAgentForTeam = {
  name: "canExecuteCheckoutSplitAgentForTeam" as const,
  input: z.null(),
  output: z.union([
    z.object({ canExecute: z.literal(true) }),
    z.object({
      canExecute: z.literal(false),
      reason: createEnum(UnableToExecuteCheckoutSplitAgentReason),
    }),
  ]),
};

export type CanExecuteCheckoutSplitAgentForTeamOutput = z.infer<
  typeof canExecuteCheckoutSplitAgentForTeam.output
>;
